/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pick_LabelInputs */

const en_model_pick_label = /** @type {(inputs: Model_Pick_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const id_model_pick_label = /** @type {(inputs: Model_Pick_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

/**
* | output |
* | --- |
* | "Model" |
*
* @param {Model_Pick_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_pick_label = /** @type {((inputs?: Model_Pick_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pick_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_pick_label(inputs)
	return en_model_pick_label(inputs)
});